import { makeCan } from './makeCan';
const can = makeCan();
// Since every access rule is under the user subject, keep things dry
export default function canUser(op, object, args) {
    return can('user', op, object, args);
}
